import React from 'react';
import RichTextContent, { RichTextContentProps } from './RichTextContent';

const ListItem = ({ node }: RichTextContentProps) => {
  return (
    <li>
      <RichTextContent node={node} />
    </li>
  );
};

export default ListItem;
